import { OtpContainer } from 'components/auth/otp/container/OtpContainer';
import { CheckContainer } from 'components/auth/check/container/CheckContainer';
import { EmailContainer } from 'components/auth/email/container/EmailContainer';
import { LoginContainer } from 'components/auth/login/container/LoginContainer';
import { TellGateway } from 'components/auth/tellGateway/TellGateway';
import TellGatewayCheck from 'components/auth/tellGateway/TellGatewayCheck';
import MaintenancePage from 'components/maintenance/MaintenancePage';
import { RouteConfig } from '../type';

const authRoutes: RouteConfig[] = [
    { path: '', element: <MaintenancePage />, pageTitle: 'Maintenance' },
    { path: 'login', element: <LoginContainer />, pageTitle: 'Login' },
    { path: 'open-banking', element: <TellGatewayCheck />, pageTitle: 'Tell Gateway Check' },
    { path: 'tell-gateway', element: <TellGateway />, pageTitle: 'Tell Gateway' },
    { path: 'email', element: <EmailContainer />, pageTitle: 'Login' },
    { path: 'checking/:id?', element: <CheckContainer />, pageTitle: 'Login' },
    { path: 'otp', element: <OtpContainer />, pageTitle: 'Login' },
];

export default authRoutes;
